import * as ActionTypes from '../../actions/allActions'

import { shuffleArray } from '../../helpers/shuffleArray'

import { affiliateShapeBg, customerShapeBg } from '../../static/svg/svg-landing'
import { affiliateHero } from '../../static/svg/affiliateHero'
import { customerHero } from '../../static/svg/customerHero'
import * as affiliateFeatureIcons from '../../static/svg/affiliate-features-icons'
import * as customerFeatureIcons from '../../static/svg/customer-features-icons'

const landingInit = {
	posts: [],
	zipCodeInfo: { covered: false, affiliates: [] },
	checkZipCodeMode: {
		shapeBackground: customerShapeBg,
		heroBackground: customerHero,
		features: [
			{ img: customerFeatureIcons.clockIcon, title: 'choose_time',    desc: 'choose_time_desc'    },
			{ img: customerFeatureIcons.phoneIcon, title: 'book_instantly', desc: 'book_instantly_desc' },
			{ img: customerFeatureIcons.thumbIcon, title: 'follow_service', desc: 'follow_service_desc' },
		],
	},
	customer: {
		shapeBackground: customerShapeBg,
		heroBackground: customerHero,
		heroTitle: 'customer_hero_header',
		heroPrompt: 'customer_hero_prompt',
		features: [
			{ img: customerFeatureIcons.clockIcon, title: 'choose_time',    desc: 'choose_time_desc'    },
			{ img: customerFeatureIcons.phoneIcon, title: 'book_instantly', desc: 'book_instantly_desc' },
			{ img: customerFeatureIcons.thumbIcon, title: 'follow_service', desc: 'follow_service_desc' },
		],
	},
	affiliate: {
		shapeBackground: affiliateShapeBg,
		heroBackground: affiliateHero,
		heroTitle: 'affiliate_hero_header',
		heroPrompt: 'affiliate_hero_prompt',
		features: [
			{ img: affiliateFeatureIcons.featureCalendarIcon, title: 'always_accessible',    desc: 'always_accessible_desc'    },
			{ img: affiliateFeatureIcons.featureAppIcon, title: 'easy_to_use', desc: 'easy_to_use_desc' },
			{ img: affiliateFeatureIcons.featureCommIcon, title: 'communication_tool', desc: 'communication_tool_desc' },
		],
	}
}
const landing = (state = landingInit, action) => {
	switch (action.type) {
		case ActionTypes.ADD_BLOG_POSTS:
			return { ...state, posts: action.posts }
		case ActionTypes.FETCH_AREAPARTNERS_SUCCESS:
			return { ...state, zipCodeInfo: {
				covered: action.data.data.length > 0,
				affiliates: shuffleArray(action.data.data).map(aff => ({
					id: aff.id,
					name: aff.attributes.commercial_name,
					logo: aff.attributes.logo
				}))
			}}
		default:
			return state
	}
}

export default landing


// WEBPACK FOOTER //
// ./src/reducers/data/landing.js